import { z } from 'zod';

import { PrimaryKeySchema, commaDelimitedList } from './utils';

/**
 * Schema for task agent runs which link tasks to agent runs
 */
export const TaskAgentRunSchema = z.object({
  taskAgentRunId: PrimaryKeySchema,
  taskId: PrimaryKeySchema,
  agentRunId: PrimaryKeySchema,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type TaskAgentRun = z.infer<typeof TaskAgentRunSchema>;

export const TaskAgentRunsSchema = z.array(TaskAgentRunSchema);

export type TaskAgentRuns = z.infer<typeof TaskAgentRunsSchema>;

export const CreateTaskAgentRunSchema = TaskAgentRunSchema.pick({
  taskId: true,
  agentRunId: true,
});

export type CreateTaskAgentRun = z.infer<typeof CreateTaskAgentRunSchema>;

export const TaskAgentRunsQueryOptionsSchema = z.object({
  taskAgentRunIds: commaDelimitedList(z.string().array()).optional(),
  taskIds: commaDelimitedList(z.string().array()).optional(),
  agentRunIds: commaDelimitedList(z.string().array()).optional(),
});

export type TaskAgentRunsQueryOptions = z.infer<
  typeof TaskAgentRunsQueryOptionsSchema
>;
